module.exports = __webpack_public_path__ + "static/cake_bouncy-215557494fe8fc0bb7139feaa4780f86.jpg";